import React, { createContext, useContext, useEffect, useState } from 'react';
import * as api from '../api/endpoints';
import {
  getToken,
  getUser,
  setSession,
  clearSession,
  subscribe,
} from './session';

const AuthContext = createContext(null);

export function AuthProvider(props) {
  const [token, setToken] = useState(getToken);
  const [user, setUser] = useState(getUser);

  // Keep React in sync when the axios interceptor clears the session on a 401.
  useEffect(function () {
    return subscribe(function () {
      setToken(getToken());
      setUser(getUser());
    });
  }, []);

  function signIn(email, password) {
    return api.login(email, password).then(function (data) {
      if (!data || !data.token) {
        throw new Error('Login succeeded but no token was returned.');
      }
      setSession(data.token, {
        id: data.id,
        email: data.email,
        username: data.username,
        first_name: data.first_name,
        passport_number: data.passport_number,
        role: data.role,
      });
      return data;
    });
  }

  function signOut() {
    clearSession();
  }

  const value = {
    token: token,
    user: user,
    isAuthenticated: Boolean(token),
    signIn: signIn,
    signOut: signOut,
  };

  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside an <AuthProvider>.');
  }
  return context;
}
